if (!customElements.get('km-product-share')) {
  customElements.define('km-product-share', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.status = this.querySelector('[role="status"]');
      this.addEventListener('pointerenter', () => this.updateLinks());
      this.addEventListener('focusin', () => this.updateLinks());
      this.addEventListener('click', async (event) => {
        this.updateLinks();
        const button = event.target.closest('[data-copy-for]');
        if (!button) return;
        const url = this.productLink();
        try {
          await navigator.clipboard.writeText(url);
          this.status.textContent = `Link copied. Paste it into your ${button.dataset.copyFor} post.`;
        } catch {
          const input = this.querySelector('input');
          input.value = url;
          input.hidden = false;
          input.focus();
          input.select();
          this.status.textContent = 'Select and copy the product link below.';
        }
        this.status.hidden = false;
      });
      this.updateLinks();
    }

    productLink() {
      const url = new URL(this.dataset.productUrl, window.location.origin);
      const variant = this.closest('product-info')?.querySelector('product-form input[name="id"]')?.value;
      if (variant) url.searchParams.set('variant', variant);
      return url.href;
    }

    updateLinks() {
      const url = encodeURIComponent(this.productLink());
      this.querySelector('[data-share-network="facebook"]').href = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
      this.querySelector('[data-share-network="x"]').href = `https://twitter.com/intent/tweet?url=${url}&text=${encodeURIComponent(this.dataset.productTitle)}`;
    }
  });
}
